import ImageAvatar, {
  STATUS as UPLOAD_STATUS,
} from "@/components/PinCreator/PinUploader/ImageAvatar";
import { uploadFile } from "@/services";
import { PlusCircleFilled } from "@ant-design/icons";
import { useMemoizedFn } from "ahooks";
import { useEffect, useRef } from "react";
import styles from "./index.module.less";

export default function ImageFileSelect(props) {
  const {
    tasks,
    tasksList,
    setTasks,
    onTaskFilePicked,
    maxCount = 1000,
  } = props;
  const abortControllerRef = useRef(null);
  //返回指定长度的随机英文字母
  const getRandomLetters = (_length) => {
    var str = "";
    for (let i = 0; i < _length; i++) {
      if (parseInt(Math.random() * 2, 10)) {
        let num = Math.random() * 26 + 65;
        str += String.fromCharCode(num);
      } else {
        let num = Math.random() * 26 + 97;
        str += String.fromCharCode(num);
      }
    }
    return str;
  };
  const guid = getRandomLetters(8);
  // const [resourcesUpdateAt, setResourcesUpdateAt] = useState();
  const onUploadClick = useMemoizedFn(() => {
    const input = document.querySelector(`#${guid}`);
    input.dispatchEvent(new MouseEvent("click"));
  });
  const onTasksDeleteClick = (r) => () => {
    delete tasks[r.uid];
    setTasks({ ...tasks });
  };
  const uploadResource = useMemoizedFn(async (resource) => {
    const { uid, file } = resource;
    // eslint-disable-next-line no-console
    console.log("开始上传：", uid, resource.name);
    resource.status = UPLOAD_STATUS.UPLOADING;
    resource.progress = 0;
    // setResourcesUpdateAt(Date.now());

    const controller = window.AbortController ? new AbortController() : null;
    abortControllerRef.current = controller;

    const ret = await uploadFile(
      file,
      ({ loaded, total }) => {
        resource.progress = (loaded / total) * 100;
        // setResourcesUpdateAt(Date.now());
      },
      controller?.signal
    );
    if (ret.err) {
      resource.status = UPLOAD_STATUS.FAILURE;
      // eslint-disable-next-line no-console
      console.log("上传失败：", uid, resource.name);
    } else {
      resource.ossFile = ret;
      resource.status = UPLOAD_STATUS.DONE;
      // eslint-disable-next-line no-console
      console.log("上传完成：", uid, resource.name);
    }
    // setResourcesUpdateAt(Date.now());
  });
  useEffect(() => {
    return () => {
      abortControllerRef.current?.abort();
    };
  }, []);
  return (
    <div className={styles.imageAvatars}>
      {tasksList.map((t) => (
        <ImageAvatar
          className={styles.tasksAImageAvatar}
          key={t.uid}
          coverUrl={t.url}
          status={t.status}
          progress={t.progress}
          onClose={onTasksDeleteClick(t)}
          onReUpload={() => uploadResource(t)}
        />
      ))}
      <div
        className={styles.tasksACreateBtn}
        onClick={onUploadClick}
        style={
          tasksList.length >= maxCount
            ? { display: "none" }
            : { display: "flex" }
        }
      >
        <PlusCircleFilled style={{ fontSize: "19px", color: "#FF5967" }} />
        <input
          id={guid}
          type={"file"}
          onChange={onTaskFilePicked}
          style={{ display: "none" }}
          accept={"image/jpeg,image/png"}
        />
      </div>
    </div>
  );
}
